// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"288":"28f3067b","453":"8b357be9","524":"0a37bf09","644":"6d4fadae","684":"e71a7707","863":"315b7803","893":"25d259ee","980":"155e0067"}[chunkId] + ".chunk.js";
};